<div class="back-header">
    <!-- Back Button -->
    <div class="back-icon" (click)="BackAbout()">
        <i class="dx-icon dx-icon-chevronleft"></i>
    </div>
    <!-- Title -->
    <div class="back-text">{{DetailsFormTitle}}</div>
</div>

<div class="form-wrapper">
    <dx-box direction="row" width="100%" [align]="'space-between'" [crossAlign]="'center'" class="input-box-section">

        <dxi-item [ratio]="6" class="separate-input-field">
            <label for="Name" class="input-label">About In English</label>
            <dx-html-editor name="Name" [(value)]="Entity.p.description_en" [height]="420" 
                placeholder="Enter About For Landing Page..."
                [toolbar]="{items: ['bold', 'italic', 'underline', 'separator', 'orderedList', 'bulletList', 'link']}"
                width="100%">
            </dx-html-editor>
        </dxi-item>
        <dxi-item [ratio]="6" class="separate-input-field">
            <label for="Name" class="input-label">देवनागरी </label>
            <dx-html-editor name="Name" [(value)]="Entity.p.description_mr" [height]="420" 
                placeholder="Enter About For Landing Page..."
                [toolbar]="{items: ['bold', 'italic', 'underline', 'separator', 'orderedList', 'bulletList', 'link']}"
                width="100%">
            </dx-html-editor>
        </dxi-item>
    </dx-box>

    <!-- READONLY OVERLAY -->
    <div *ngIf="IsReadOnlyMode" class="readonly-overlay"></div>
</div>
<div class="button-section" [align]="'center'" style="margin-top: 5rem">
    <app-cancelbutton text="Cancel" (click)="BackAbout()"></app-cancelbutton>
    <dx-button [elementAttr]="{ class: 'save-button' }" (click)="SaveAbout()" [disabled]="isSaveDisabled"
        [text]="IsNewEntity ?  'Save' : 'Update'" type="default" stylingMode="contained" *ngIf="CanAddOrEdit">
    </dx-button>
</div>